import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { getLabel } from 'utils/widgetTypeUtil'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { AudienceWordCloudWidget } from 'schemas/AudienceWordCloudWidgetSchema'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from '../../../share/guards'
import WordCloudWidgetDataGuards from '../../share/guards/WordCloudWidgetDataGuards'
import RunSearchEffect from '../../share/RunSearchEffect'
import Table from '../../share/Table'
import { Measure } from '../../../../../enums'
import InsightModal from '../../share/InsightModal'
import useSelectedInsights from '../../hooks/useSelectedInsights'

const TableDisplay = ({ widgetId }: { widgetId: number }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceWordCloudWidget>(widgetId)

  const {
    isModalOpen,
    setIsModalOpen,
    selection,
    countType,
    detailSetting,
    handleTableClick,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId} measure={Measure.POSTS} hasEmojiCategory>
          <WidgetLoadingGuard widgetId={widgetId}>
            <WordCloudWidgetDataGuards widgetId={widgetId}>
              <Table widgetId={widgetId} onRowClick={handleTableClick} />
            </WordCloudWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicNotSelectedGuard>
      <InsightModal
        widgetSettingWithSelection={widgetSettingWithSelection}
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={countType}
        selection={selection}
        onClose={() => {
          setIsModalOpen(false)
        }}
        detailSetting={detailSetting}
      />
    </UnexpectedErrorBoundary>
  )
}

export default TableDisplay
